import {ChairsSelect} from './ChairsSelect';

export default ChairsSelect;
